import Gridable, {GridableColumn} from "../../components/Gridable";
import translate from "../../i18n/Translator";
import React from "react";
import {NonIntegratedCfdi} from "../../model/CfdisNonIntegrated";
import {Button, Grid} from "@material-ui/core";
import DateFormat from "../../components/DateFormat";
import {DoneAllRounded, ReportOutlined} from "@material-ui/icons";
import {useHistory} from "react-router-dom";
import NumberFormat from "react-number-format";

export interface CancellationRequestedCfdisProps {
    data: NonIntegratedCfdi[];
    status : string
}

export default function CancellationRequestedCfdisTable(props: CancellationRequestedCfdisProps) {
    const history = useHistory();
    const getSerieFolio = (item:NonIntegratedCfdi) =>{
        return [item.cfdi_raw.serie, item.cfdi_raw.folio].filter(el => !!el).join(" ")
    }

    const getIconSatStatus = (status : string) =>{
        switch (status){
            case "ACTIVE":
                return <ReportOutlined style={{color: "#F44336"}} />;
            case "CANCELLED":
                return <DoneAllRounded style={{color: "#1F679F"}}/>;
            default:
                return <ReportOutlined/>;
        }
    }

    const getSatStatus = (status : string) =>{
        switch (status){
            case "ACTIVE":
                return translate("cfdis_non_integrated.sat_status.active") as string;
            case "CANCELLED":
                return translate("cfdis_non_integrated.sat_status.cancelled") as string;
            default:
                return (props.status === "VERIFYING")?
                translate("cfdis_non_integrated.sat_status.verifying") as string :
                translate("cfdis_non_integrated.sat_status.pending") as string;
        }
    }

    const getColumns = (): GridableColumn<NonIntegratedCfdi>[] => {
        const columns = [
            {
                title: translate("cfdis_non_integrated.cancellation_requested.columns.serie_folio") as string,
                converter: (item) => (
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                        {getSerieFolio(item)}
                    </div>
                ),
                xs: 3,
                sm:3,
                md:2,
                lg:2,
                xl:1,
                justify: "flex-start"
            },
            {
                title: <strong style={{textAlign: 'right', display:'block'}}>{translate("cfdis_non_integrated.cancellation_requested.columns.date") as string}</strong>,
                converter: (item, index: number) =>
                    <Grid alignContent="flex-end">{item.cfdi_raw.fecha ? (<DateFormat date={item.cfdi_raw.fecha} format="DD/MM/yyyy" />) : "---"}</Grid>,
                justify: "flex-end",
                xs: 2,
                sm: 2,
                md: 2,
                lg: true,
                xl: true,
            },
            {
                title: translate("cfdis_non_integrated.cancellation_requested.columns.reason") as string,
                converter: (item) =>
                    (<span style={{ overflowX: 'auto', width: '100%' }}> {(item?.cancellation_reason ?? "--")} </span>),
                xs: 3,
                sm: 3,
                md: 2,
                lg: 2,
                xl: 3,
            },
            {
                title: translate("cfdis_non_integrated.cancellation_requested.columns.receiver") as string,
                converter: (item) =>
                    (<span>
                        {item.cfdi_raw.emisor.rfc}
                    </span>),
                xs: false,
                sm: false,
                md: 2,
                lg: true,
                xl: true
            },
            {
                title: <strong style={{textAlign: 'right'}}>{translate("cfdis_non_integrated.cancellation_requested.columns.amount") as string}</strong>,
                converter: (item) =>
                    (<span>
                        <NumberFormat value={item.cfdi_raw.total}
                                      prefix="$ " suffix={` ${item.cfdi_raw.moneda}`}
                                      decimalScale={2} fixedDecimalScale={true} thousandSeparator=","
                                      displayType="text" />
                    </span>),
                xs: false,
                sm: false,
                md: false,
                lg: 2,
                xl: true,
                justify: "flex-end"
            },
            {
                title: <strong style={{textAlign: 'right', display:'block'}}>{translate("cfdis_non_integrated.cancellation_requested.columns.cancellation_date") as string}</strong>,
                converter: (item, index: number) =>
                    <span>{item.cfdi_raw.fecha ? (<DateFormat date={item.cancellation_requested_date} format="DD/MM/yyyy" />) : "---"}</span>,
                justify: "flex-end",
                xs: 2,
                sm: 2,
                md: 2,
                lg: true,
                xl: true,
            },
            {
                title: translate("cfdis_non_integrated.cancellation_requested.columns.status") as string,
                converter: (item) =>
                    (<>
                        <Grid container alignItems="center" alignContent="center">
                            <Grid item xs="auto" >
                                <Grid item xs={12} >
                                    <Grid container justify="flex-start" alignItems="center" alignContent="center" spacing={1}>
                                        <Grid item xs="auto">
                                            {getIconSatStatus(item.sat_status)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs>
                                <Grid item xs={12} >
                                    {getSatStatus(item.sat_status)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </>),
                xs: 2,
                sm: 2,
                md: 2,
                lg: true,
                xl: true
            },
        ] as GridableColumn<NonIntegratedCfdi>[];

        return columns.filter(col => col != null);
    };

    const goToPage = () => {
        history.replace('/providerCfdis/new'); // reemplaza la entrada actual
    };
    return (
        <div className="PaperPagination">
            <Gridable
                items={props.data || []}
                loading={false}
                empty={translate("reports.empty") as string}
                columns={getColumns()}
            />
            <Grid container alignItems="flex-end" justifyContent="flex-end" spacing={1}>
                <Grid item lg={2} style={{paddingRight:"20px"}}>
                    <Button onClick={goToPage} variant="contained" color="primary" fullWidth size="medium" disabled={props.status !== "CANCELLED"}>
                        {translate("buttons.continue")}
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}